exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-template-selector-js": () => import("./../../../src/templates/TemplateSelector.js" /* webpackChunkName: "component---src-templates-template-selector-js" */)
}

